import { render, staticRenderFns } from "./procurementManage.vue?vue&type=template&id=22b1ecea&"
import script from "./procurementManage.vue?vue&type=script&lang=js&"
export * from "./procurementManage.vue?vue&type=script&lang=js&"
import style0 from "./procurementManage.vue?vue&type=style&index=0&id=22b1ecea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports